import "./App.css";
import "./index.css";
import { React } from "react";
import { portalAuth } from "./utils/portalAuth";
import "./utils/axiosInstance"; // registers global axios interceptors (token injection + 401 redirect)
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/superAdmin/dashboard/Header";
import Footer from "./components/superAdmin/footer/Footer";
import Default from "./routes/Default";
import { Suspense } from "react";
import { Spinner } from "react-bootstrap";
import ExhibitorDashboardNavbar from "./components/exhibitor/exhibitor_dashboard/ExhibitorDashboardNavbar";
import VisitorForm from "./components/HtmlMainPage/MainPage";
import InvitedVIPGuestList from "./components/exhibitor/SubAdminArea/InvitedVIPGuestList";
import AdminInvitedVIPGuestList from "./components/AdminVIP/AdminInvitedVIPGuestList";
import MainRoute from "./routes/MainRoute";
import SuperAdminAreaLogin from "./components/superAdmin/Settings/SuperAdminAreaLogin";
import AdminVIPLogin from "./components/AdminVIP/AdminVIPLogin";
import ExhibitorLogin from "./components/exhibitor/Form/ExhibitorLogin";
import CabManagementLogin from './components/CabManagment/login.js';
import HotelManagementLogin from './components/HotelManagement/login.js';
import ExhibitorStaff from "./components/visitorform/ExhibitorStaff";
import ExhibitorVip from "./components/visitorform/ExhibitorVip";
import ExhibitorOwner from "./components/visitorform/ExhibitorOwner";
import VendorOwner from "./components/visitorform/VendorOwner";
import VendorStaff from "./components/visitorform/VendorStaff";
import Wrong404 from "./404/Wrong404";
import FrontEndPage from "./components/HtmlMainPage/FrontPage";
import HospitalityLogin from "./components/Hospitality/HospitalityLogin";
import CabServiceLogin from "./components/CabService/CarServiceLogin";
import FlightServicelogin from "./components/FlightService/FlightServiceLogin";
import BuyerRegistration from "./components/HtmlMainPage/BuyerRegistration";
import KceVisitorRegistration from "./components/HtmlMainPage/KceVisitorRegistration";
import NewVisitorForm from "./components/HtmlMainPage/NewVisitorForm";
import NewBojVisitorForm from "./components/HtmlMainPage/NewBojVisitorForm";
import SuccessFullPage from "./components/HtmlMainPage/SuccessFullPage";
import FailedRedirection from "./components/HtmlMainPage/FailedRedirection";
import PaymentComponent from "./components/HtmlMainPage/PaymentComponent";
import BuyerAdminLogin from "./components/BuyerAdmin/BuyerAdminLogin";
import VisitorAdminLogin from "./components/visitorAdmin/VisitorAdminLogin";
import InventoryLogin from "./components/Inventory/InventoryLogin";
import PrintPage from "./components/HtmlMainPage/PrintPage";
import AddArea from "./components/superAdmin/area/AddArea";
import AreaList from "./components/superAdmin/area/AreaList";
import BuyerVisitorForm from "./components/HtmlMainPage/BuyerVisitorForm";
import BuyerLogin from "./components/HtmlMainPage/BuyerLogin";
import UndertakingForm from "./components/exhibitor/stallLayout/undertaking_form.js";
import ImportExhibitors from "./components/superAdmin/ImportExhibitors/ImportExhibitors";

// ─── One-time migration: wipe legacy shared keys so old sessions don't collide ─
const _LEGACY_KEYS = ['jff_token', 'permission', 'user_id', 'type_of_user', 'category'];
if (!localStorage.getItem('__portal_auth_migrated__')) {
  _LEGACY_KEYS.forEach(k => localStorage.removeItem(k));
  localStorage.setItem('__portal_auth_migrated__', '1');
}

// Make portalAuth available globally so components don't need their own import.
// ESLint is told about this global via the "globals" key in package.json eslintConfig.
window.portalAuth = portalAuth;

function App() {

  return (
    <>
      {/* <MainPage/> */}
      {/* <Suspense fallback={<Spinner animation="border" size="lg" />}> */}
      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center content-height">
            Loading... &nbsp; &nbsp;
            <Spinner animation="border" size="lg" />
          </div>
        }
      >
        <Routes>
          {/* <Route path="/adminvip/login" element={<AdminVIPLogin />} /> */}
          <Route path="/superadmin/login" element={<SuperAdminAreaLogin />} />
          <Route path="/superadmin/import-exhibitors" element={<ImportExhibitors />} />
          <Route path="/exhibitor/login" element={<ExhibitorLogin />} />
          <Route path="/hotelmanagement/login" element={<HotelManagementLogin/>} />
          <Route path="/cabmanagement/login" element={<CabManagementLogin/>} />
          {/* <Route path="/hospitality/login" element={<HospitalityLogin />} />
          <Route path="/cab-service/login" element={<CabServiceLogin />} />
          <Route path="/buyer-admin/login" element={<BuyerAdminLogin />} />
          <Route path="/visitor-admin/login" element={<VisitorAdminLogin />} /> */}
          {/* <Route path="/agent/login" element={<ExhibitorLogin />} />
          <Route path="/associate/login" element={<ExhibitorLogin />} />
          <Route path="/sponser/login" element={<ExhibitorLogin />} /> */}
          {/* inventory */}
          {/* <Route path="/inventory/login" element={<InventoryLogin />} /> */}

          {/* <Route
            path="/flight-service/login"
            element={<FlightServicelogin />}
          /> */}
          <Route path="/404" element={<Wrong404 />} />
          {/* <Route path="/" element={<FrontEndPage />} />
          <Route path="/e-card" element={<PrintPage />} /> */}

          {/* <Route
            path="/exhibitor-staff-registration"
            element={<ExhibitorStaff />}
          /> */}
          {/* <Route path="/registration" element={<VisitorForm />} /> */}

          {/* <Route path="/payment-successful" element={<SuccessFullPage />} />
          <Route path="/payment" element={<PaymentComponent />} />

          <Route path="/payment-failed" element={<FailedRedirection />} />

          <Route
            path="/visitor"
            element={<NewVisitorForm />}
          />
          <Route
            path="/isjs-visitor-registration"
            element={<NewVisitorForm />}
          /> */}
          {/*  */}
          <Route
            path="/boj-visitor-registration"
            element={<NewBojVisitorForm />}
          />
          <Route
            path="/boj-registration"
            element={<NewBojVisitorForm />}
          />

          <Route
            path="/exhibitor-vip-registration"
            element={<ExhibitorVip />}
          />
          <Route
            path="/buyer-registration"
            element={<BuyerLogin />}
          />

          {/* undertaking route */}

          <Route
  path="/exhibitor/undertaking-form"
  element={<UndertakingForm />}
/>

          {/* <Route
            path="/exhibitor-owner-registration"
            element={<ExhibitorOwner />}
          /> */}
          {/* <Route
            path="/vendor-owner-registration/:barcode"
            element={<VendorOwner />}
          />
          <Route
            path="/vendor-staff-registration/:barcode"
            element={<VendorStaff />}
          />
          <Route path="/vip-guest-registration" element={<ExhibitorVip />} />
          <Route path="/buyer-registration" element={<BuyerRegistration />} /> */}
          <Route path="/404" element={<Wrong404 />} />
          <Route path="*" element={<Default />} />
          <Route path="header" element={<Header />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
